<template>
	<div class="clearfix">
		<ul class="pagination pull-right">
			<li v-if="getData('current_page', 1) > 1">
				<a href="#" aria-label="Halaman Pertama" @click.prevent="navigateTo(1)">
					<span aria-hidden="true">«</span>
				</a>
			</li>
			<li v-for="(page, index) in pagesNumber" :key="index" :class="{'active': page == getData('current_page', 1)}">
				<a href="#" :aria-label="`Halaman ${page}`" @click.prevent="navigateTo(page)">
					{{ page }}
				</a>
			</li>
			<li v-if="getData('current_page', 1) < getData('last_page', 1)">
				<a 
					href="#" 
					aria-label="Halaman Terakhir" 
					@click.prevent="navigateTo(getData('last_page', 1))">
					<span aria-hidden="true">»</span>
				</a>
			</li>
		</ul>
	</div>
</template>

<script>
export default {
	computed: {
		pagesNumber() {
			if (!this.getData('to')) {
				return [];
			}

			let from = this.getData('current_page') - this.offset;

			if (from < 1) {
				from = 1;
			}

			let to = from + (this.offset * 2);

			if (to >= this.getData('last_page', 1)) {
				to = this.getData('last_page', 1);
			}

			let pagesArray = [];

			for (let page = from; page <= to; page++) {
				pagesArray.push(page);
			}

			return pagesArray;
		},
	},
	methods: {
		getData(key, defaultValue = null) {
			if (typeof this.pagination[key] !== 'undefined') {
				return this.pagination[key];
			}

			return defaultValue;
		},
		navigateTo(page) {
			this.$emit('navigate', page)
		}
	},
	props: {
		pagination: {
			type: Object,
			required: true
		},
		offset: {
			type: Number,
			default: 2,
		},
	},
}
</script>
